"use client";
import clsx from "clsx";
import type { FooterStoryblok } from "@/generated/sb/sb-types";
import { NewlsetterSubscribeEvent } from "@/lib/utils/gtm/components";
import styles from "./index.module.css";

interface INewsletterSection {
  newsletterTitle?: string;
  newsletterText?: string;
  privacyPolicyLink?: FooterStoryblok["privacyPolicyLink"];
  formId: string;
  alignment?: "left" | "center" | "right" | "";
}

const NewsletterSection = ({
  newsletterTitle,
  newsletterText,
  formId,
  alignment = "left",
}: INewsletterSection) => {
  return (
    <div className={styles.newsletter}>
      <div className={clsx(styles.newsletter__inner, styles[alignment])}>
        {newsletterTitle && <h2>{newsletterTitle}</h2>}
        {newsletterText && (
          <div>
            <p>{newsletterText}</p>
          </div>
        )}

        <div className={`klaviyo-form-${formId}`}></div>
        <NewlsetterSubscribeEvent />
      </div>
    </div>
  );
};

export default NewsletterSection;
